import { UserLoginAction } from "../../actions/UserLoginAction";
import { VendorCreationAction } from "../../actions/vendor/VendorCreationAction";
import { UserFile } from "../../models/UserFile";

export interface VendorCreateState {
  [key: string]: any;
  VendorName: string;
  VendorType: string;
  VendorCategory: string;
  VendorCategoryId: number;
  RMCategoryIds: number[];
  RMCategoryNames :  string[];
  OnBoardReasonNames : string[];
  OnBoardReasonIds: number[];
  OnBoardReasonDescription: string;
  TypeSubCategory: string;
  ReconAC: string;
  Email: string;
  Requestory: string;
  CompanyCode: string;
  DepartmentId: number;
  DepartmentName: string;
  CompanyCodeCountry: string;
  PoCodes: string[];
  //HodApprovers: string[];
  //ExcoApprovers: string[];
  //SBUSCHeadApprovers: string[];
  //GSSCCategoryLeadApprovers: string[];
  FirstApprovers: string[];
  SecondApprovers: string[];
  IsBulk: boolean;
  VendorNominatedBy: string;
  IsVendorFillForm2: boolean;
  IsConfirmExistingData: boolean;
  RequestId: number;
  RequestTypeId: number;
  RequestNumber: string;
  vendorId: Number;
  RequestApprovalPoint: number;
  MobileNumber: string;
  //allCoCodes: Array<string>;
  isForeignSupplier: boolean;
  isUrgentRequest: boolean;
  reconACDesc: string;
  vendorNominatedByDesc: string;
  typeSubCategoryDesc: string;
  vendorTypeDesc: string;
  vendorNo: string;
  isWhtAvailable: boolean;
  Comment:string;
  PreviousApprovalPointId?: number;
  AddressCoutry: string;
  TermsOfTrade: string;
  PrefPayMethod: string[];
  CreditPeriodDays: string;
  purposeCode: string;
  orderCurrency: string;
  alternativeCurrency: string[];
  OnboardReasonFile: UserFile;
  ProcurementCategoryIds: number[];
  ProcurementSubcategoryIds: number[];
  ProcurementSubcategoryNames: string[];
  InstructionKey: string;
  IsUrgentRequest: boolean;
  IsCategoryManager: boolean;
  SpendManagedById: number | null;
  SpendManagedByName : string;
  TemporaryApprovalDays:number | null;
}

const initialState = {
  VendorName: "",
  VendorType: "",
  VendorCategory: "",
  VendorCategoryId: 0,
  RMCategoryNames :[],
  OnBoardReasonNames :[],
  RMCategoryIds:[],
  OnBoardReasonIds:[],
  OnBoardReasonDescription:"",
  TypeSubCategory: "",
  ReconAC: "",
  Email: "",
  Requestory: "",
  CompanyCode: "",
  DepartmentId: 0,
  DepartmentName: "",
  CompanyCodeCountry: "",
  PoCodes: [],
  // HodApprovers: [],
  // ExcoApprovers: [],
  // SBUSCHeadApprovers:[],
  // GSSCCategoryLeadApprovers:[],
  FirstApprovers: [],
  SecondApprovers: [],
  VendorNominatedBy: "",
  IsVendorFillForm2: false,
  IsConfirmExistingData: false,
  IsBulk:true,
  RequestId: 0,
  RequestTypeId: 0,
  RequestNumber: "",
  vendorId: 0,
  RequestApprovalPoint: 0,
  MobileNumber: "",
  //allCoCodes: [],
  isForeignSupplier: false,
  isUrgentRequest: false,
  reconACDesc: "",
  vendorNominatedByDesc: "",
  typeSubCategoryDesc: "",
  vendorTypeDesc: "",
  vendorNo: "",
  isWhtAvailable: false,
  Comment: "",
  AddressCoutry: "",
  TermsOfTrade: "",
  PrefPayMethod: [],
  CreditPeriodDays: "",
  purposeCode:"",
  orderCurrency: "",
  alternativeCurrency: [],
  OnboardReasonFile: { fileId: 0, fileName: "", filePath: "" },
  ProcurementCategoryIds : [],
  ProcurementSubcategoryIds : [],
  ProcurementSubcategoryNames: [],
  InstructionKey: "",
  IsUrgentRequest: false,
  IsCategoryManager: false,
  SpendManagedById: 0,
  SpendManagedByName: "",
  TemporaryApprovalDays:null
};

export function VendorCreateReducer(
  state: VendorCreateState = initialState,
  action: VendorCreationAction
): VendorCreateState {
  switch (action.type) {
    case "ON_CHANGE_VENDOR_CREATION_DATA":
      return {
        ...state,
        [action.payload[0]]: action.payload[1],
      };
    case "ON_REMOVE_VENDOR_CREATION_PURCH_ORG":
      return {
        ...state,
        PoCodes: state.PoCodes.filter((code) => {
          return code !== action.payload[0];
        }),
      };
    case "ON_REMOVE_VENDOR_CREATION_APPROVER1":
      return {
        ...state,
        FirstApprovers: state.FirstApprovers.filter((email) => {
          return email !== action.payload[0];
        }),
      };
    case "ON_REMOVE_VENDOR_CREATION_APPROVER2":
      return {
        ...state,
        SecondApprovers: state.SecondApprovers.filter((email) => {
          return email !== action.payload[0];
        }),
      };
    case "ON_ORDERCURRENCY_UPDATE_VENDOR_CREATION":
      return {
        ...state,
        "orderCurrency": action.payload[0],
        "alternativeCurrency": action.payload[0]
          ? state.alternativeCurrency.filter((code: string) => {
            return action.payload[0] !== code;
          })
          : [],
      };
    case "ON_REMOVE_VENDOR_CREATION_SETTLEMENT_CURRENCY":
      return {
        ...state,
        alternativeCurrency: state.alternativeCurrency.filter((altCurrency) => {
          return altCurrency !== action.payload[0];
        }),
      };  
    case "ON_REMOVE_VENDOR_CREATION_PAYMENT_METHOD":
      return {
        ...state,
        PrefPayMethod: state.PrefPayMethod.filter((prefPayMethod) => {
          return prefPayMethod !== action.payload[0];
        }),
      };  
    case "ON_REMOVE_VENDOR_CREATION_RMCategory":
      return {
        ...state,
        RMCategoryIds: state.RMCategoryIds.filter((id) => {
          return id !== action.payload[0];
        }),
      };
    case "ON_REMOVE_VENDOR_CREATION_PROCUREMENT_CATEGORY":
      return {
        ...state,
        ProcurementCategoryIds: state.ProcurementCategoryIds.filter((id) => {
          return id !== action.payload[0];
        }),
      };  
    case "ON_REMOVE_VENDOR_CREATION_PROCUREMENT_SUB_CATEGORY":
      return {
        ...state,
        ProcurementSubcategoryIds: state.ProcurementSubcategoryIds.filter((id) => {
          return id !== action.payload[0];
        }),
      };  
    case "ON_REMOVE_VENDOR_CREATION_ONBOARDING_REASON":
      return {
        ...state,
        OnBoardReasonIds: state.OnBoardReasonIds.filter((Id) => {
          return Id !== action.payload[0];
        }),
      }; 
    case "ON_SUCCESS_VENDOR_CREATION":
      return {
        ...state,
        VendorName: action.payload.vendorName,
        VendorType: action.payload.vendorType, //"X001",
        VendorCategory : action.payload.VendorCategory,
        TypeSubCategory: action.payload.typeSubCategory,
        ReconAC: action.payload.reconAC,         
        Email: action.payload.email,
        VendorCategoryId : action.payload.VendorCategoryId,
        vendorOnboardingReasonName : action.payload.OnBoardReason,
        Requestory: action.payload.requestor, 
        DepartmentId: action.payload.departmentId, 
        CompanyCode: action.payload.companyCode, 
        PoCodes: action.payload.poCodes, 
        //HodApprovers: action.payload.hodApprovers ? action.payload.hodApprovers : [], 
        //ExcoApprovers: action.payload.excoApprovers ? action.payload.excoApprovers : [], 
        //SBUSCHeadApprovers: action.payload.SBUSCHeadApprovers ? action.payload.SBUSCHeadApprovers : [], 
        //GSSCCategoryLeadApprovers: action.payload.GSSCCategoryLeadApprovers ? action.payload.GSSCCategoryLeadApprovers : [], 
        FirstApprovers: action.payload.firstApprovers ? action.payload.firstApprovers : [], 
        SecondApprovers: action.payload.secondApprovers ? action.payload.secondApprovers : [], 
        OnBoardReasonIds : action.payload.OnBoardReasonIds ? action.payload.OnBoardReasonIds : [], 
        RMCategoryIds : action.payload.RMCategoryIds ? action.payload.RMCategoryIds : [], 
        VendorNominatedBy: action.payload.vendorNominatedBy,
        IsVendorFillForm2: action.payload.isVendorFillForm2,
        IsConfirmExistingData: action.payload.isConfirmExistingData,
        IsBulk: action.payload.IsBulk,
        RequestId: action.payload.requestId,
        RequestTypeId: action.payload.requestTypeId,
        RequestNumber: action.payload.requestNumber,
        vendorId: action.payload.vendorId,
        RequestApprovalPoint: action.payload.requestApprovalPoint,
        MobileNumber: action.payload.mobileNumber,
        isForeignSupplier: action.payload.isForeignSupplier,
        isUrgentRequest: action.payload.isUrgentRequest,
        Comment: action.payload.comment,
        AddressCoutry: action.payload.addressCoutry,
        TermsOfTrade: action.payload.termsOfTrade,
        PrefPayMethod: action.payload.prefPayMethod ? action.payload.prefPayMethod : [],
        CreditPeriodDays: action.payload.creditPeriodDays,
        alternativeCurrency: action.payload.alternativeCurrency ? action.payload.alternativeCurrency : [],
        orderCurrency: action.payload.orderCurrency,
        OnboardReasonFile: action.payload.onboardReasonFile ? action.payload.onboardReasonFile : initialState.OnboardReasonFile,
        ProcurementCategoryIds: action.payload.procurementCategoryIds ? action.payload.procurementCategoryIds : [],
        ProcurementSubcategoryIds: action.payload.procurementSubcategoryIds ? action.payload.procurementSubcategoryIds : [],
        InstructionKey: action.payload.instructionKey,
        IsUrgentRequest: action.payload.isUrgentRequest,
        IsCategoryManager: action.payload.isCategoryManager,
        SpendManagedById: action.payload.spendManagedById,
        purposeCode: action.payload.purposeCode,
        TemporaryApprovalDays: action.payload.temporaryApprovalDays
        
      };
    case "ON_SUCCESS_VENDOR_REQUEST_GET":
      return {
        ...state,
        VendorName: action.payload.vendorName,
        VendorType: action.payload.vendorType, 
        VendorCategoryId : action.payload.vendorCategoryId,
        VendorCategory : action.payload.vendorCategory,
        TypeSubCategory: action.payload.typeSubCategory,
        ReconAC: action.payload.reconAC, 
        Email: action.payload.email,
        Requestory: action.payload.requestor, 
        DepartmentId: action.payload.departmentId, 
        DepartmentName: action.payload.departmentName,
        CompanyCode: action.payload.companyCode, 
        CompanyCodeCountry: action.payload.companyCodeCountry,
        RMCategoryIds : action.payload.rmCategoryIds ? action.payload.rmCategoryIds : [], 
        RMCategoryNames :  action.payload.rmCategoryNames ? action.payload.rmCategoryNames : [],
        OnBoardReasonIds : action.payload.onBoardReasonIds ? action.payload.onBoardReasonIds : [], 
        OnBoardReasonNames : action.payload.onBoardReasonNames ? action.payload.onBoardReasonNames : [],
        OnBoardReasonDescription : action.payload.onBoardReasonDescription ,
        PoCodes: action.payload.poCodes, 
        //HodApprovers: action.payload.hodApprovers ? action.payload.hodApprovers : [], 
        //ExcoApprovers: action.payload.excoApprovers ? action.payload.excoApprovers : [], 
        //SBUSCHeadApprovers: action.payload.SBUSCHeadApprovers ? action.payload.SBUSCHeadApprovers : [], 
        //GSSCCategoryLeadApprovers: action.payload.GSSCCategoryLeadApprovers ? action.payload.GSSCCategoryLeadApprovers : [],
        FirstApprovers: action.payload.firstApprovers ? action.payload.firstApprovers : [],
        SecondApprovers: action.payload.secondApprovers ? action.payload.secondApprovers : [],
        VendorNominatedBy: action.payload.vendorNominatedBy,
        IsVendorFillForm2: action.payload.isVendorFillForm2,
        IsConfirmExistingData: action.payload.isConfirmExistingData,
        RequestId: action.payload.requestId,
        RequestTypeId: action.payload.requestTypeId,
        RequestNumber: action.payload.requestNumber,
        vendorId: action.payload.vendorId,
        MobileNumber: action.payload.mobileNumber,
        //allCoCodes: action.payload.allCoCodes,
        isForeignSupplier: action.payload.isForeignSupplier,
        isUrgentRequest: action.payload.isUrgentRequest,
        reconACDesc: action.payload.reconACDesc,
        vendorNominatedByDesc: action.payload.vendorNominatedByDesc,
        typeSubCategoryDesc: action.payload.typeSubCategoryDesc,
        vendorTypeDesc: action.payload.vendorTypeDesc,
        vendorNo: action.payload.vendorNo,
        isWhtAvailable: action.payload.isWhtAvailable,
        Comment:action.payload.comment,
        AddressCoutry: action.payload.addressCoutry,
        TermsOfTrade: action.payload.termsOfTrade,
        PrefPayMethod: action.payload.prefPayMethod ? action.payload.prefPayMethod : [],
        CreditPeriodDays: action.payload.creditPeriodDays,
        alternativeCurrency: action.payload.alternativeCurrency ? action.payload.alternativeCurrency : [],
        orderCurrency: action.payload.orderCurrency,
        OnboardReasonFile: action.payload.onboardReasonFile ? action.payload.onboardReasonFile : initialState.OnboardReasonFile,
        ProcurementCategoryIds: action.payload.procurementCategoryIds ? action.payload.procurementCategoryIds : [],
        ProcurementSubcategoryIds: action.payload.procurementSubcategoryIds ? action.payload.procurementSubcategoryIds : [],
        ProcurementSubcategoryNames : action.payload.procurementSubcategoryNames ? action.payload.procurementSubcategoryNames : [],
        InstructionKey: action.payload.instructionKey,
        IsUrgentRequest: action.payload.isUrgentRequest,
        IsCategoryManager: action.payload.isCategoryManager,
        IsBulk: action.payload.isBulk,
        SpendManagedById: action.payload.spendManagedById,
        SpendManagedByName: action.payload.spendManagedByName,
        purposeCode: action.payload.purposeCode,
        TemporaryApprovalDays:action.payload.temporaryApprovalDays
      };
    case "RESET_FOR_CREATE":
      initialState.Requestory = action.payload[0];
      return Object.assign(state, initialState);
    default:
      return state;
  }
}
